<nav class="wm-studio-header navbar navbar-default">
  <div  class= "top-container">
    <div class="navbar-header" id="wms-studio-logo">
      <a class="navbar-brand" name="wm-goto-project-list"  (click)="closeProject()" title="{{locale.LABEL_BACK_TO_PROJECTS}}">
        <span class="wm-logo-container">
          <img alt="{{locale.LABEL_BACK_TO_PROJECTS}}" [src]="'assets/logo.png' | versionManager" height="26" />
        </span>
      </a>
    </div>

    <ul class="nav navbar-nav">
      <li *ngIf="projectEdnDetails.branchType !== 'BRANCH'" class="project-name" title="{{projectDetails.displayName}}"
        (click)="preferences?.project?.branch?.switch && toggleProjectsList()"
        [ngClass]="{'project-name': projectEdnDetails.artifact?.artifactType !== 'PROJECTCORE', 'project-branch-name': projectEdnDetails.artifact?.artifactType === 'PROJECTCORE', 'project-name-org': this.selectedOrganization?.mode === 'ORG'}">
        <div class="header-app-label">
        <div tabindex="-1" class="branch-name" *ngIf="projectEdnDetails.artifact?.artifactType !== 'PROJECTCORE'">
          <span>{{projectDetails.displayName | middleEllipsis:9:9:20}}</span>
          <span class="dirty-icon" *ngIf="wsManager.activeWS && wsManager.activeWS.active && isActiveWSDirty()">*</span></div>

        <div tabindex="-1" class="branch-name" *ngIf="projectEdnDetails.artifact?.artifactType === 'PROJECTCORE'">
          <p class="project-title" title="{{projectDetails.displayName}}">{{projectDetails.displayName}}</p>
          <div class="core-project-title"
            title="{{projectEdnDetails.artifact?.name +  (projectEdnDetails.artifact?.readableVersion
           ? ' v' + projectEdnDetails.artifact.readableVersion + (projectEdnDetails.artifact?.version ? '(' + projectEdnDetails.artifact.version + ')' : ''): ' v' + projectEdnDetails.artifact.version) }}">
            <span>{{projectEdnDetails.artifact.name}}</span>
                <span>{{ projectEdnDetails.artifact?.readableVersion ? 'v' + projectEdnDetails.artifact.readableVersion +
                (projectEdnDetails.artifact?.version ? '(' + projectEdnDetails.artifact.version + ')' : '') :  'v' + projectEdnDetails.artifact.version }}</span>
          </div>
        </div>

        <p class="active-branch">
          <span class="branch-type-icon"><i class="wm-icon wms wms-main "></i></span>{{projectEdnDetails.vcsBranch}}</p>
<!--        <div  class="wm-breadcrumb-arrow" *ngIf="preferences?.project?.branch?.switch">-->
<!--          <i class="wm-icon wms wms-workspace-icon"></i>-->
<!--        </div>-->
        </div>
      </li>
      <li *ngIf="projectEdnDetails.branchType === 'BRANCH'" class="project-name"
      (click)="preferences?.project?.branch?.switch && toggleProjectsList()" [ngClass]="{'project-name-org': this.selectedOrganization?.mode === 'ORG'}">
        <!-- <div tabindex="-1" class="branch-icon"><i class="fa fa-code-fork"></i></div> -->
         <div class="header-app-label">
          <div tabindex="-1" class="branch-name">
            <p class="project-title" [attr.title]="projectDetails.displayName">{{projectDetails.displayName | middleEllipsis:11:11:23}}</p>
          </div>
            <p class="active-branch" [attr.title]="projectEdnDetails.vcsBranch"><span class="branch-type-icon"><i class="wm-icon wms wms-branch "></i></span>{{projectEdnDetails.vcsBranch}}</p>
        </div>
      </li>

      <div tabindex="-1" id="project-branch-container" class="project-switch-container project-branch-container"
        *ngIf="showBranchesContainer && preferences?.project?.branch?.switch">
        <div class="proj-name">
          <div class="project-name" [title]="projectName">{{projectName}}
              <p class="project-sub"><i class="wms" [ngClass]="{
    'wms-styles': projectService.isPrism(),
    'wms-web': !projectService.isPrism() && !projectService.isNativeMobileApplicationType(),
    'wms-mobile-dark': projectService.isNativeMobileApplicationType()
  }"></i><span >{{ projectService.isPrism() ? locale.LABEL_DESIGN_SYSTEM + ' (' + (isNativeMobileApplicationType ? locale.LABEL_MOBILE_HEADING : locale.LABEL_WEB) + ')' : (isNativeMobileApplicationType? locale.LABEL_REACTNATIVE:locale.LABEL_WEB)}}</span></p>
          </div>

           <i class="close wi wi-close" title="{{locale.LABEL_DIALOG_CLOSE}}" (click)="closeProjectSwitchDialog()"></i>
        </div>
        <wms-search name="wm-proj-branch-search" placeholder="{{locale.LABEL_SEARCH_PROJECT_BRANCH}}"
          title="{{locale.LABEL_SEARCH_TITLE}}..." (onSearch)="onBranchSearch($event)">
        </wms-search>
        <ul>
          <wms-spinner *ngIf="projectActivityLoading" name="branch-members-spinner" size="sm"></wms-spinner>
          <ng-container
            *ngFor="let project of filteredBranches?.slice(0,projectsVisibleCount) | orderBy: '-lastAccessedDate'">
            <li *ngIf="project.status !== 'ARCHIVED'" (click)="switchProject(project)"
              title="{{project.studioProjectId === projectEdnDetails.studioProjectId ? locale.MSG_CANNOT_SWITCH_TO_SAME_PROJECT  : projectDetails.vcsBranch }}"
              [ngClass]="{'active': project.name === projectEdnDetails.name && project.vcsBranch === projectEdnDetails.vcsBranch, 'disabled' : project.studioProjectId === projectEdnDetails.studioProjectId}">
              <div class="project-name branch-name">{{project.vcsBranch}}</div>
            </li>
          </ng-container>
          <a class="view-more-projs" *ngIf="filteredBranches?.length>projectsVisibleCount"
            (click)="showMoreProjects($event, filteredBranches.length)">
            <h5>{{locale.LABEL_VIEW_MORE}}</h5>
          </a>
        </ul>
      </div>
      <!--Recent list-->
      <li class="wm-project-workspace" id="wms-recent-workspace" [ngClass]="{'disable-pointer-events' : studioFactory.hasMergeChangesConflicts}">
        <wms-recent-ws-list></wms-recent-ws-list>
      </li>
    </ul>
    <ul class="nav navbar-nav navbar-center studio-header" [ngClass]="{'disable-pointer-events' : studioFactory.hasMergeChangesConflicts}">
      <!--AUTO SAVE-->
      <ng-container *ngIf="wsManager.activeWSCategory === 'PAGE'">
        <li class="autosave-content" >
          <span  *ngIf="pageWsService.showAutoSave"><i class="'wm-icon " [ngClass]="wsManager.activeWS && wsManager.activeWS.active && isActiveWSDirty()? 'wms wms-autorenew fa-spin' : 'wms wms-check-circle'"></i> <span>{{wsManager.activeWS && wsManager.activeWS.active && isActiveWSDirty() ?  locale.LABEL_SYNC : locale.LABEL_SAVED}} </span></span>
        </li>


      </ng-container>

    </ul>

<!--    canvas option-->

    <div class="canvas-wm-navigation">
      <div class="left-header" #dynamicLeftHeader></div>
      <div class="wm-actions-center"  *ngIf="wsManager.activeWSCategory=== 'PAGE'" >
      <span *wmsFeature='!preferences.project?.pages.edit' title="{{locale.LABEL_SCHEMA_READONLY_MODE}}" class="readonly-schema">
          <span>{{locale.LABEL_SCHEMA_READONLY_MODE}}</span>
      </span>
      </div>
      <div class="wm-actions-left"  *ngIf="wsManager.activeWSCategory=== 'PAGE'"  >
       <ul class="nav navbar-nav tabs btn-group">
      <li  [class]="pageWsService.isActivetabDesign === 'DESIGN' ? 'active' : ' '" ><button class="btn" name="canvas" [disabled]="isWSSwitchBlocked" (click)="beforeTabSwitch('DESIGN',{tab:'DESIGN'});" >Canvas</button></li>
         <li  [class]="pageWsService.isActivetabDesign !== 'DESIGN' ? 'active' : ' '" class="dropdown" dropdown>
           <button class="btn" name="MARKUP" [disabled]="isWSSwitchBlocked" (click)="beforeTabSwitch(pageWsService.selectedTab,{tab:pageWsService.selectedTab});" >{{locale['LABEL_WORKSPACE_'+pageWsService.selectedTab]}}</button>

           <button type="button" dropdownToggle class="btn top-tab-btn dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
             <span class="visually-hidden"> <i class="wms wms-caret-down"></i></span>
           </button>
           <ul id="dropdown-split" *dropdownMenu class="dropdown-menu wm-default-menu " role="menu" aria-labelledby="button-split">
             <li>
               <a title="Script" (click)="beforeTabSwitch('MARKUP',{tab:'MARKUP'});">
                 <span class="dropdown-item">{{locale.LABEL_WORKSPACE_MARKUP}}</span>
               </a>
             </li>
             <li>
             <li>
               <a title="Script" (click)="beforeTabSwitch('SCRIPT',{tab:'SCRIPT'});">
                 <span class="dropdown-item">{{locale.LABEL_WORKSPACE_SCRIPT}}</span>
               </a>
             </li>
             <li>
               <a title="Style" (click)="beforeTabSwitch('STYLE',{tab:'STYLE'});">
                 <span class="dropdown-item">{{locale.LABEL_WORKSPACE_STYLE}}</span>
               </a>
             </li>
           </ul>

         </li>

<!-- variable Dropdown -->
         <ng-container >

         <li class="dropdown" *wmsFeature="preferences.project?.variables.view"  dropdown>
           <button name="wm-header-variables" class=" btn dropdown-toggle"
                   dropdownToggle title="{{locale.LABEL_VARIABLES}}">
             <i class="wms wms-variables"></i>{{locale.LABEL_VARIABLES}}<span class="caretStyles wms wms-caret-down"></span>
           </button>
           <ul id="dropdown-basic" *dropdownMenu class=" wm-default-menu dropdown-menu" role="menu" aria-labelledby="button-basic">
             <li>
               <a title="{{locale.LABEL_VARIABLES}}"
                  (click)="openDialogWithId('variableModal'); variableService.selectedVariableView='Variables'">
                 <i class="wms wms-add-variable"></i>
                 <span class="dropdown-item">{{locale.LABEL_VARIABLES}}</span>
               </a>
             </li>
             <li>
               <a title="{{locale.LABEL_ACTIONS}}"
                  (click)="openDialogWithId('variableModal'); variableService.selectedVariableView='Actions'">
                 <i class="wms wms-action-variables"></i>
                 <span class="dropdown-item">{{locale.LABEL_ACTIONS}}</span>
               </a>
             </li>
           </ul>
         </li>
         </ng-container>

    </ul>
    </div></div>

    <ul class="nav navbar-nav navbar-center studio-header" [ngClass]="{'disable-pointer-events' : studioFactory.hasMergeChangesConflicts}">

      <!-- Publish Prefab -->
      <li *ngIf="isPrefabType" id="wms-header-btn-publish" class="dropdown" dropdown container="body"  title="{{locale.LABEL_PUBLISH}}">
        <!-- <a name="header-action-publish" class="dropdown-toggle action-publish" dropdownToggle title="{{locale.LABEL_PUBLISH_PREFAB}}">
          <div class="title"><i class="wm-icon24 wms wms-export"></i> <span class="wms wms-arrow-down caret"></span>

          </div>
        </a> -->
        <wms-prefab-publish *dropdownMenu></wms-prefab-publish>
        <!--Prefab -->
        <wms-dialog
        id="publish-to-project"
        customClasses="modal publish-prefab-dialog large wm-studio-dialog fade"
        >
          <wms-publish-to-project></wms-publish-to-project>
        </wms-dialog>
        <wms-dialog id="publish-to-team" customClasses="widget-config-dialog team-publish-dialog large project wm-studio-dialog select-platform" [closeOnEscape]="false">
          <wms-publish-to-team></wms-publish-to-team>
        </wms-dialog>
        <wms-dialog
        id="publish-to-workspace"
        customClasses="publish-workspace-dialog medium wm-studio-dialog studio-artifacts"
        >
          <wms-publish-to-workspace></wms-publish-to-workspace>
        </wms-dialog>
      </li>
      <!-- TODO: copy from ng1 implementation -->



    </ul>

    <ul class="nav navbar-nav layout-nav" >
      <div #dynamicRightHeader></div>


<ng-container *ngIf="wsManager.activeWSCategory === 'PAGE'" >


<!--  edittor Setting Option -->

 <div class="wm-right-actions">
  <ul class="nav navbar-nav" *ngIf="pageWsService.isActivetabDesign !== 'DESIGN'">
    <li class="code-editor-config dropdown" dropdown [attr.title]="locale.ICONTITLE_CODE_EDITOR_CONFIG"
        [insideClick]="true">
      <button dropdownToggle type="button" class="dropdown-toggle btn-transparent wm-workspace-action"
              aria-controls="dropdown-basic">
        <i class="wm-icon24 wms wms-theme-setting"></i>
      </button>
      <ul class="list-inline wm-default-menu dropdown-menu" role="menu" aria-labelledby="button-basic">
        <span class="caret-up"></span>
        <li>
          <div>
            <h5>Code Editor Settings</h5>
            <ul class="wm-ui-ace-toolbar">
              <li class="ace-toolbar-action themes">
                <div>
                  <label class="col-md-5">Theme:</label>
                  <select class="col-md-7" id="theme" size="1" (change)="pageWsService.changeEditorTheme($event)">
                    <optgroup *ngFor="let group of pageWsService.groupThemes" [label]="group.label">
                      <option
                        *ngFor="let theme of group.themes"
                        [value]="theme.value"
                        [selected]="pageWsService.editorOptions.theme === theme.value">
                        {{ theme.name }}
                      </option>
                    </optgroup>
                  </select>
                </div>
              </li>
              <li class="ace-toolbar-action font-size">
                <div>
                  <label class="col-md-5">Font Size:</label>
                  <select class="col-md-7" id="fontsize" size="1" (change)="pageWsService.changeEditorFontSize($event)">
                    <option value="12" *ngIf="pageWsService.editorOptions.fontSize===12" selected>Small</option>
                    <option value="12" *ngIf="pageWsService.editorOptions.fontSize!==12">Small</option>
                    <option value="14" *ngIf="pageWsService.editorOptions.fontSize===14" selected>Medium</option>
                    <option value="14" *ngIf="pageWsService.editorOptions.fontSize!==14">Medium</option>
                    <option value="16" *ngIf="pageWsService.editorOptions.fontSize===16" selected>Large</option>
                    <option value="16" *ngIf="pageWsService.editorOptions.fontSize!==16">Large</option>
                    <option value="20" *ngIf="pageWsService.editorOptions.fontSize===20" selected>Extra Large</option>
                    <option value="20" *ngIf="pageWsService.editorOptions.fontSize!==20">Extra Large</option>
                  </select>
                </div>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </li>
  </ul>
  </div>


<!--layout option-->

  <ng-container  *ngIf="pageWsService.isActivetabDesign === 'DESIGN'"  >
  <ng-container *wmsFeature="preferences.project?.pages.edit">
    <li class="dropdown wm-design-more-actions wm-workspace-action"
        [ngClass]="{'open': pageWsService.templateMenu.visible}" *ngIf="pageWsService.layoutOptions?.length > 0"
        title="{{locale.LABEL_WIDGET_LAYOUT}}">

      <a name="header-Layout-options" (click)="pageWsService.templateMenu.show($event)" >
        <p class="title"><i class="wm-icon24 wms wms-template-layout"></i></p>
      </a>

      <div class="wm-default-menu dropdown-menu wm-template-list" *ngIf="pageWsService.templateMenu.visible">
        <ul>
          <li *ngFor="let layout of pageWsService.layoutOptions" class="wm-template-list-item" title="{{layout.name}}">
            <div class="wm-template-list-item-content" [ngClass]="{'active': layout.selected}"
                 (click)="pageWsService.selectLayout($event, layout)">
              <i class="wm-template-thumbnail"
                 [style.background-image]="'url(' + ('assets/images/layouts/' + layout.category + '/' + layout.id + '/' + layout.thumbnail | versionManager) + ')'"></i>
              <span class="wm-template-name">{{layout.name}}</span>
            </div>
          </li>
        </ul>
      </div>
      </li>
  </ng-container>
  </ng-container>


  <li class="dropdown wm-design-more-actions wm-workspace-action" container="body" *ngIf="projectService.isNativeMobileApplicationType()"
      [ngClass]="{'prefab-project': projectService.isPrefabType()}"  title="{{locale.PAGE_ADJUSTMENTS}}" dropdown>
    <a>
      <p class="title">
        <button name="header-action-project" class="dropdown-toggle wm-icon24 wms wms-tab-mobile dropdown-toggle" dropdownToggle></button>
      </p>
    </a>
    <ul *dropdownMenu class="wm-default-menu dropdown-menu-right dropdown-menu devices-dropdown">
      <ng-container>
        <li class="layout-dropdown" *ngFor="let device of pageWsService.availableDevices">
          <a (click)="pageWsService.canvasResize(device)"
             title="{{locale[device.labelKey]}}">
            <i class="fa" [ngClass]="{'fa-check': pageWsService.selectedViewPort.id==device.id}"></i>
            <span>{{locale[device.labelKey]}}</span>
            <span class="studio-device-spec">{{device.width}}*{{device.height}}</span>
          </a>
        </li>
      </ng-container>
    </ul>
  </li>
</ng-container>

        </ul>

    <ul class="nav navbar-nav navbar-right">
      <!-- preview -->
      <li id="wms-run-project" class="wms-run-project" *ngIf="!isNativeMobileApplicationType">
                <a name="header-action-run" (click)="runProject()" [title]="locale.LABEL_PAGE_PREVIEW">
                  <p class="title"><i class="wm-icon24 wms wms-play-prototype-new"></i></p>
                </a>
      </li>
      <li id="wms-run-project" *ngIf="isNativeMobileApplicationType" class="wms-run-project run-native dropdown">
        <div class="native-play-button" name="header-action-run" [title]="(!isPagePreviewAvailable()) ? locale.LABEL_TOOLTIP_RUN : locale.LABEL_PAGE_PREVIEW_TITLE" #dropdownPreview="bs-dropdown" dropdown [autoClose]="true">
          <button class="play-btn" (click)="runProject()">
            <i class="wm-icon24 wms wms-play-prototype-new"></i>
          </button>
          <button class="dropdown-toggle" dropdownToggle *ngIf="isNativeMobileApplicationType">
            <span class="wms wms-arrow-down caret "></span>
          </button>
          <ul class="wm-default-menu dropdown-menu dropdown-menu-left" *dropdownMenu>
            <li>
              <a name="wm-header-clean-preview" (click)="cleanPreview()">
                <i class="wms wms-clear-preview"></i>
                <span class="menu-name">{{locale.LABEL_REBUILD_PREVIEW}}</span>
              </a>
            </li>
          </ul>
        </div>
      </li>


   <!-- VCS -->
      <li id="wms-header-btn-vcs" class="dropdown" dropdown  #dropdown="bs-dropdown"  show="root.headerVCSDD" container="body"  *wmsFeature="preferences.project?.vcs.view" [ngClass]="{'disable-pointer-events' : studioFactory.hasMergeChangesConflicts,'disabled':studioFactory.showApplyMergeChangesWS}" [title]="studioFactory.showApplyMergeChangesWS ? 'VCS actions are not allowed while a merge is in progress.' : ''">
        <a name="header-action-vcs" class="dropdown-toggle action-vcs" dropdownToggle title="{{locale.MESSAGE_VCS_HINT}}" (click)="false" >
          <div class="title"><i class="wm-icon24 wms wms-vcs"></i> <span class="wms wms-arrow-down caret"></span>
            <p><span *ngIf="vcsService.hasVCSChanges" class="vcs-changes-marker">*</span></p>
          </div>
        </a>
        <wms-vcs-menu-item *dropdownMenu [dropdown]="dropdown" ></wms-vcs-menu-item>
        <wms-vcs-dialog></wms-vcs-dialog>
      </li>

            <!-- i18N -->
      <!-- <li id="wms-header-btn-localization" *wmsFeature="preferences.project?.i18n?.configure" title="{{locale.se]="true"LABEL_APP_MESSAGES_TOOLTIP}}" [ngClass]="{'disable-pointer-events' : studioFactory.hasMergeChangesConflicts}">
        <a (click)="manageAppMessages()" name="wm-header-appmessages">
          <p class="title"><i name="wm-locale-message-icon" class="wm-icon24 wms wms-translate"></i></p>
        </a>
      </li> -->


      <!-- Export menu -->
      <li dropdown class="dropdown" container="body" #dropdownExport="bs-dropdown" hideIcon="root.headerExportDD" *wmsFeature="preferences.project?.actions.sources?.exportAsZip || preferences.project?.actions.sources?.cordovaExport || preferences.project?.actions.build.exportAsWAR || preferences.project?.actions.sources?.prefabExport || preferences.project?.actions.sources?.templateBundleExport || preferences.project?.actions.build.publishProjectShellToTeam || preferences.project?.actions.build.publishProjectShellToWorkspace || preferences.project?.actions.build.publishThemeToTeam" [ngClass]="{'disable-pointer-events' : studioFactory.hasMergeChangesConflicts}">
        <a name="header-action-export" class="dropdown-toggle" dropdownToggle title="{{locale.LABEL_EXPORT_PROJECT}}"  (click)="false"  >
          <p class="title"><i class="wm-icon24 wms wms-more-vert"></i></p>
        </a>
      <wms-export-menu (getReference)="assignReference($event)" ></wms-export-menu>
      </li>



      <!-- Project Updates -->
      <li  class="dropdown " container="body" dropdown #dropdownProjectUpdates="bs-dropdown"  [autoClose]="false"   (onShown)="onProjectUpdatesDropdownToggle(true)" [ngClass]="{'disable-pointer-events' : studioFactory.hasMergeChangesConflicts}">
        <a name="header-action-update"
          class="dropdown-toggle icon-container" dropdownToggle title="{{locale.LABEL_UPDATE}}"
           (click)="projectUpdatesService.showUpdatesAvailableNotification = false; $event.stopPropagation();"   >
          <p class="title"><i  name="project_updates" class="wm-icon24 wms wms-project-update"></i></p>
          <span class="wms wms-arrow-down caret"></span>
          <span *ngIf="projectUpdatesService.updatesInfo.updatesCount ||jobstatusService.jobDataInProgress.length " class="notification-badge"></span>
        </a>
            <wms-project-updates-notification [dropdown]="dropdownProjectUpdates"></wms-project-updates-notification>
            <wms-project-updates-list *dropdownMenu [dropdown]="dropdownProjectUpdates"></wms-project-updates-list>
      </li>

      <!-- user information-->
      <li class="wm-studio-user-info " >
            <wms-studio-user-info></wms-studio-user-info>
      </li>
      <!-- custom logo -->
      <li *ngIf="user?.enterpriseLogoUrl">
          <img [src]="user.enterpriseLogoUrl" height="38"/>
      </li>
    </ul>

    <div class="float-right network-status" ng-class="{'online': isOnline, 'offline': !isOnline}">
      <i class="network-icon wms" ng-class="{'wms-wifi': isOnline, 'wms-signal-wifi-off': !isOnline}" title="isOnline ? locale.ICONTITLE_NETWORK_STATUS_ONLINE : locale.ICONTITLE_NETWORK_STATUS_OFFLINE}}"></i>
    </div>
  </div>
</nav>

<wms-dialog id="vcsSyncDialog" [content]="vcsSyncDialog" customClasses="sync-vcs-project-dialog wm-studio-dialog small">
</wms-dialog>
<ng-template #vcsSyncDialog>
  <wms-push-changes-dialog ></wms-push-changes-dialog>
</ng-template>
<wms-dialog id="deployDialog" customClasses="wm-deploy-dialog medium" [content]="deployDialog" ></wms-dialog>
<ng-template #deployDialog>
  <wms-deploy-dialog ></wms-deploy-dialog>
</ng-template>

<wms-dialog id="appMessagesDialog" [content]="appMessagesContent" customClasses="large app-messages-dialog">
</wms-dialog>
<ng-template #appMessagesContent>
  <wms-locale-dialog (onModalClose)="closeDialogWithId('appMessagesDialog')"></wms-locale-dialog>
</ng-template>


<wms-dialog id="vcsUserCredentials" [content]="vcsUserCredentialsContent" customClasses="user-vcs-credentials-dialog app-confirm-dialog small wm-studio-dialog"></wms-dialog>
<ng-template #vcsUserCredentialsContent>
  <wms-vcs-user-credentials (close)="closeDialogWithId('vcsUserCredentials')"></wms-vcs-user-credentials>
</ng-template>

<wms-dialog id="popupBlockerDialog" customClasses="small wm-studio-dialog popup-blocker-run-mode">
  <wms-dialog-header (onClose)="closeDialogWithId('popupBlockerDialog')" title="{{locale.TITLE_POPUP_BLOCKER}}"></wms-dialog-header>
  <wms-dialog-body>
    <p class="app-dialog-body-title">{{locale.MESSAGE_POPUP_BLOCKER}}</p>
    <p class="manual-launch-container"><a class="app-anchor btn btn-primary" [href]="previewService.previewUrl" (click)="closeDialogWithId('popupBlockerDialog')" target="_blank"
    >{{locale.LABEL_MANUAL_LAUNCH}}</a>
    </p>
  </wms-dialog-body>
</wms-dialog>

<wms-dialog id="projectChangesDialog"  [content]="projectChangesDialog"  customClasses="project-changes-dialog large wm-studio-dialog" ></wms-dialog>
<ng-template #projectChangesDialog>
  <wms-vcs-project-changes-dialog [prefabConflicts]="projectUpdatesService.prefabConflicts" [themeConflicts]="projectUpdatesService.themeConflicts"></wms-vcs-project-changes-dialog>
</ng-template>

<wms-dialog id="sourceCodeUpdatesDialog" [content]="sourceCodeUpdatesDialog" customClasses="project-changes-dialog large wm-studio-dialog"></wms-dialog>
<ng-template #sourceCodeUpdatesDialog>
  <wms-source-code-updates-dialog [sourceCodeUpdates]="projectUpdatesService.sourceCodeUpdates"></wms-source-code-updates-dialog>
</ng-template>

<wms-unsaved-changes-dialog id="browser" [message]="locale.LABEL_CLOSE_PROJECT_DIALOG_TEXT" [saveBtnLabel]="locale.LABEL_SAVE" [cancelBtnLabel]="locale.LABEL_DISCARD"
                            (closeEvent)="closeDialogWithId('unsavedChangesDialog_browser')" (saveEvent)="confirmDialogAction(true)" (cancelEvent)="confirmDialogAction(false)"></wms-unsaved-changes-dialog>


<wms-dialog id="prefabConflictDialog"  [content]="prefabConflictDialog"  customClasses="large   wm-studio-dialog prefab-conflict-dialog" ></wms-dialog>
<ng-template #prefabConflictDialog>
  <wms-prefab-confict-dialog></wms-prefab-confict-dialog>
</ng-template>

<wms-dialog id="EditInWMInfoScreen" [content]="EditInWMInfoScreen" name="wm-build-logo-dialog" customClasses="edit-in-wm-info-dialog  wm-studio-dialog">
</wms-dialog>

<ng-template #EditInWMInfoScreen >
  <wms-edit-in-wm-info></wms-edit-in-wm-info>
</ng-template>


<wms-dialog id="errorAnalysisDialogue" [content]="errorAnalysisDialogue" customClasses="errorAnalysisDialogue small wm-studio-dialog">
</wms-dialog>
<ng-template #errorAnalysisDialogue>
  <wms-dialog-header (onClose)="closeDialogWithId('errorAnalysisDialogue')" title="{{locale.LABEL_ERROR_LOG_ANALYSIS}}"></wms-dialog-header>
  <wms-dialog-body>

    <div class="app-dialog-body modal-body errorAnalysisDialogue" name="errorAnalysisDialogue">
      <form enctype="multipart/form-data" class="wm-form">
          <div class="form-group app-composite-widget clearfix">
            <label class="control-label  app-label title col-xs-3">{{locale.LABEL_SUMMARY}}</label>
            <textarea class="col-xs-6 app-textarea form-control errorLogTextarea" [ngModel]="notificationService.errorLogAnalysisSummary"
                      name="summary" readonly="true" rows="8">
            </textarea>
          </div>
        <div class="form-group app-composite-widget clearfix">
          <label class="control-label  app-label title col-xs-3">{{locale.LABEL_AI_SUGGESTION}}</label>
          <textarea class="col-xs-6 app-textarea form-control errorLogTextarea" [ngModel]="notificationService.errorLogAnalysisSuggestion"
                    name="suggestion" readonly="true"  rows="8">
            </textarea>
        </div>

      </form>
    </div>
  </wms-dialog-body>
  <wms-dialog-footer>
    <button class="cancel-action btn app-button btn-secondary ng-isolate-scope" (click)="closeDialogWithId('errorAnalysisDialogue')">{{locale.LABEL_CANCEL}}</button>
  </wms-dialog-footer>
</ng-template>
